export function redirectCartPage() {
  window.location.href = '/cart';
}

export function redirectCheckoutPage(args = '') {
  window.location.href = `/checkout${args}`;
}
